
// 配置路由
import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '@/views/index.vue'
import Home from '@/views/home.vue'// 首页
import questionBank from '@/views/questionBank/questionBank.vue'//面试题库
import aiHelper from '@/views/aiHelper.vue' //AI助手
import loginPage from '@/views/login/loginPage.vue' //登录/注册页
import index from '@/views/userPullDown/index.vue'//个人信息首页
import userInfo from '@/views/userPullDown/userInfo.vue'//个人中心页面
import message from '@/views/userPullDown/message.vue'//消息通知页面
import credits from '@/views/userPullDown/credits.vue'//积分兑换页面
import approved from '@/views/userPullDown/approved.vue'//审核记录页面

import delicacyProject from '@/views/appProject/delicacyProject.vue'//精品项目页面
import delicacyProjectAdd from '@/views/appProject/delicacyProjectAdd.vue'//精品项目页面-新增
import delicacyProjectDetail from '@/views/appProject/delicacyProjectDetail.vue'//精品项目-详情页面

import questionBankAdd from '@/views/questionBank/questionBankAdd.vue'//面试题库新增页面
import questionBankDetails from '@/views/questionBank/questionBankDetails.vue'//面试题库详情页面
import questionBankEdit from '@/views/questionBank/questionBankEdit.vue' // 面试题库编辑页面
import resourceDownload from '@/views/resourceDownload/resourceDownload.vue' //资源下载页面
import resourceDownloadDetails from '@/views/resourceDownload/resourceDownloadDetails.vue' //资源详情页面
import resourceDownloadAdd from '@/views/resourceDownload/resourceDownloadAdd.vue' //上传资源页面





Vue.use(VueRouter)

const router = new VueRouter({
  routes: [
    // 配置首页路由
    {
      path: '/',
      component: Index,
      redirect: '/home', //重定向到home页
      // 二级路由配置
      children: [
        { path: '/home', component: Home }, //首页
        { path: '/questionBank', component: questionBank },//面试题库
        { path: '/aiHelper', component: aiHelper },


        { path: '/delicacyProject', component: delicacyProject },//精品项目
        { path: '/delicacyProject/delicacyProjectAdd', component: delicacyProjectAdd },//精品项目-新增页面
        { path: '/delicacyProject/delicacyProjectDetail/:projectId', component: delicacyProjectDetail },//精品项目-详情页面


        { path: '/questionBankAdd', component: questionBankAdd },//面试题库新增页面
        { path: '/questionBank/questionDetails/:bankId', component: questionBankDetails },//面试题库详情页面
        { path: '/questionBank/bankContentEdit', component: questionBankEdit }, //面试题库编辑页面

        {path:'/resourceDownload',component:resourceDownload}, //资源下载页面
        {path:'/resourceDownload/resourceDownloadDetails/:resourceId',component:resourceDownloadDetails}, //资源详情页面
        {path:'/resourceDownloadAdd',component:resourceDownloadAdd}, // 上传资源页面
        // 个人中心页面路由
        {
          path: '/userIndex',
          component: index,
          redirect: '/userIndex/userInfo', //重定向到个人中心页
          // 子路由
          children: [
            { path: '/userIndex/userInfo', component: userInfo },//个人中心
            { path: '/userIndex/message', component: message },//消息通知页面
            { path: '/userIndex/credits', component: credits },//积分兑换页面
            { path: '/userIndex/approved', component: approved },//审核记录页面
          ]
        },

      ]

    },
    // 配置登录/注册路由
    { path: '/loginPage', component: loginPage }
  ]
});


// 全局导航守卫
router.beforeEach((to, from, next) => {
  const accessUserData = localStorage.getItem('accessUserData') === null ? false : true;

  // 判断如果是登录页面，则直接通过
  if (to.fullPath === '/loginPage') {
    next();
  } else {
    if (!accessUserData) {
      next({
        path: '/loginPage'
      });
    } else {
      next();
    }
  }
});

export default router
